const GUEST_PREVIEW_ID_KEY = "learning-buddy-guest-id";
const GUEST_PREVIEW_COUNT_KEY = "learning-buddy-guest-count";
const GUEST_PREVIEW_PREFIX = "guest:";

function getStorage() {
  if (typeof window === "undefined") return null;
  return window.localStorage;
}

function createGuestPreviewId() {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return `${GUEST_PREVIEW_PREFIX}${crypto.randomUUID()}`;
  }

  return `${GUEST_PREVIEW_PREFIX}${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
}

export function getGuestPreviewId() {
  const storage = getStorage();
  if (!storage) return `${GUEST_PREVIEW_PREFIX}server`;

  const existing = storage.getItem(GUEST_PREVIEW_ID_KEY);
  if (existing) return existing;

  const nextId = createGuestPreviewId();
  storage.setItem(GUEST_PREVIEW_ID_KEY, nextId);
  return nextId;
}

export function getGuestPreviewCount() {
  const storage = getStorage();
  if (!storage) return 0;

  const value = Number(storage.getItem(GUEST_PREVIEW_COUNT_KEY) ?? "0");
  return Number.isFinite(value) && value > 0 ? Math.floor(value) : 0;
}

export function setGuestPreviewCount(count: number) {
  const storage = getStorage();
  if (!storage) return;

  storage.setItem(GUEST_PREVIEW_COUNT_KEY, String(Math.max(0, Math.floor(count))));
}